<template>
  <div v-if="request" class="p-3 text-left">
    <div class="d-flex align-items-center">
      <i class="el-icon-arrow-left mr-3 circle text-white bg-primary p-3 cursor-pointer" @click="$router.go(-1)" />
      <h2>{{ $t('general.details') }}</h2>
    </div>
    <hr />
    <OrderCustomerCard :customer="user" :delivery-address="null" :delivery-date="null" />
    <el-card class="mt-3">
      <div slot="header" class="font-weight-bold">
        <span>Muster</span>
        <span>({{ request.get('type') }})</span>
      </div>
      <div>
        <div>
          <div class="font-weight-bold">
            Anmerkungen
          </div>
          <div>{{ request.get('notes') }}</div>
        </div>
        <el-divider />
        <div v-for="item in request.get('content').data" :key="item.id" class="text-center border-bottom py-2 my-2">
          <img class="border rounded" :alt="item.id" :src="item.image" />
          <div class="d-flex align-content-between mt-1 justify-content-center">
            <div v-for="color in item.colors" :key="color.id" class="d-flex align-items-center mr-3">
              <div class="preview-color-square rounded mr-2 font-weight-bold" :style="{ background: color.color.hex }">
                <span v-if="color.amount > 0">{{ color.amount }}%</span>
              </div>
              <span class="small">{{ `${color.color.name}` }}</span>
              <span v-if="color.color.code" class="small">{{ `(${color.color.code})` }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import OrderCustomerCard from '../detail-order-request/components/OrderCustomerCard';
import User from '../../../api/dto/User';
export default {
  name: 'AdminMixerRequestDetailView',
  components: { OrderCustomerCard },
  props: {},
  async mounted() {
    let query = new this.$parse.Query('MixerRequest');
    query.include('user');
    this.request = await query.get(this.$route.params.id);
    this.user = new User(this.request.get('user'));
  },
  destroyed() {},
  data() {
    return {
      request: null,
      user: null,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.preview-color-square {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-color-square span {
  padding: 2px;
  font-size: 10px;
  border-radius: 5px;
  text-align: center;
  color: white;
  text-shadow: 1px 1px 1px black, 1px -1px 1px black, -1px 1px 1px black, -1px -1px 1px black;
}
</style>
